import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=7c2136e2&scoped=true"
import script from "./SecondStep.vue?vue&type=script&lang=ts"
export * from "./SecondStep.vue?vue&type=script&lang=ts"
import style0 from "./SecondStep.vue?vue&type=style&index=0&id=7c2136e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2136e2",
  null
  
)

export default component.exports